import { typeNoteCustomerOptions } from "../assets/constants/default_options"
import { ColumnsType } from "antd/es/table"


export const breakdownColumns: ColumnsType<any> = typeNoteCustomerOptions.map(opt => ({
    key: opt.value,
    title: opt.label,
    dataIndex: 'breakdown',
    render: (breakdown: any) => breakdown?.[opt.value],
}))
